import APIService from '.';

export default class ScreenshotService extends APIService {
  host() {
    return this.servicesHost();
  }

  getWebsiteImage(businessId: string) {
    return this.get(`/screenshot/${businessId}`);
  }
}
